function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { getProductTypeLabel } from '@finect/front-resources/Products';
import { withSubscriptions } from '@finect/front-core/User';
import { ContentProductCard } from '../../../Products';
import { ArticleCard } from '../../ArticleCard';
import { WithRightContent, MainColumn, Three, Two } from '../partials';
import { ProductCard } from '../../../Products/List/GridView/ProductCard';
import { Question } from '../../../Questions';
import { Inner, EvergreenArticlesBlock, ProductsGrid, ProductsBlock, Title } from './partials';
import { Manufacturers } from './Manufacturers';
import { SubsectionTitle } from './SubsectionTitle';
var FEATURED_ARTICLES_QTY = 2;
var ACADEMY_ARTICLES_QTY = 4;
var PRODUCTS_QTY = 5;
var DTopicSection = function DTopicSection(_ref) {
  var title1 = _ref.title1,
    title2 = _ref.title2,
    tag = _ref.tag,
    _ref$actions = _ref.actions,
    actions = _ref$actions === void 0 ? {} : _ref$actions,
    subscriptionsProps = _ref.subscriptionsProps,
    subscriptionsActions = _ref.subscriptionsActions,
    _ref$withProducts = _ref.withProducts,
    withProducts = _ref$withProducts === void 0 ? true : _ref$withProducts,
    _ref$withQuestions = _ref.withQuestions,
    withQuestions = _ref$withQuestions === void 0 ? true : _ref$withQuestions,
    _ref$articlesIsClient = _ref.articlesIsClient,
    articlesIsClient = _ref$articlesIsClient === void 0 ? false : _ref$articlesIsClient;
  var onManagerChange = actions.onManagerChange;
  var allArticles = tag.articles,
    products = tag.products,
    productType = tag.productType,
    questions = tag.questions,
    _tag$managers = tag.managers,
    managers = _tag$managers === void 0 ? [] : _tag$managers,
    _tag$managersContents = tag.managersContents,
    managersContents = _tag$managersContents === void 0 ? [] : _tag$managersContents;
  var goodArticles = allArticles;
  var articlesWithImage = goodArticles.filter(function (_ref2) {
    var image = _ref2.image;
    return Boolean(image);
  });
  var featuredArticle = articlesWithImage.slice(0, FEATURED_ARTICLES_QTY);
  var academyArticles = allArticles.filter(function (item) {
    return !featuredArticle.map(function (_ref3) {
      var id = _ref3.id;
      return id;
    }).includes(item.id);
  }).slice(0, ACADEMY_ARTICLES_QTY);
  var showingProducts = products.slice(0, PRODUCTS_QTY);
  var onAction = function onAction(product) {
    actions.onProductRequest(product);
  };
  var onFollow = function onFollow(value) {
    var follow = subscriptionsProps.subscriptions.products.includes(value);
    subscriptionsActions.onAction('product', 'subscribe', value, !follow);
  };
  return React.createElement(Inner, null, React.createElement(WithRightContent, {
    gap: "36px"
  }, React.createElement("div", null, title1 && React.createElement(Title, null, title1), React.createElement(Two, null, featuredArticle.map(function (article, i) {
    return React.createElement(ArticleCard, {
      key: i,
      variant: "medium",
      withAuthor: false,
      article: article,
      withImage: true,
      withDate: false,
      isClient: articlesIsClient
    });
  }))), React.createElement(EvergreenArticlesBlock, null, title2 && React.createElement(Title, null, title2), React.createElement("div", null, academyArticles.map(function (article, i) {
    return React.createElement(ArticleCard, {
      key: i,
      compact: true,
      variant: "small",
      withAuthor: false,
      article: article,
      withImage: true,
      withDate: false,
      withDescription: false,
      isClient: articlesIsClient
    });
  })))), managers.length ? React.createElement(ProductsBlock, {
    topMargin: true
  }, React.createElement(SubsectionTitle, {
    title: "Contenido de nuestros grupos",
    align: "left"
  }), React.createElement(Manufacturers, {
    managers: managers,
    onTabChange: onManagerChange,
    managersContents: managersContents || []
  })) : null, withProducts && React.createElement(ProductsBlock, {
    topMargin: true
  }, React.createElement(SubsectionTitle, {
    title: "".concat(getProductTypeLabel(productType, 'shortPlural', 'none'), " seleccionados"),
    align: "left"
  }), ['iic'].includes(productType.category) ? React.createElement(ProductsGrid, null, showingProducts.map(function (item) {
    return _objectSpread(_objectSpread({}, item.entity), {}, {
      subtype: item.subtype
    });
  }).map(function (product, i) {
    return React.createElement(ProductCard, {
      key: i,
      product: product,
      following: subscriptionsProps.subscriptions.products.includes(product.id),
      onFollow: onFollow,
      onAction: onAction ? function () {
        return onAction(product);
      } : null,
      withSPA: true
    });
  })) : null, !['iic'].includes(productType.category) ? React.createElement(ProductsGrid, null, showingProducts.map(function (product, i) {
    return React.createElement(ContentProductCard, {
      key: i,
      variant: "cta",
      product: product,
      position: i,
      following: subscriptionsProps.subscriptions.products.includes(product.entity.id),
      onFollow: onFollow,
      onAction: onAction ? function () {
        return onAction(product);
      } : null,
      withSPA: true
    });
  })) : null), withQuestions && React.createElement(ProductsBlock, {
    topMargin: true
  }, React.createElement(SubsectionTitle, {
    title: "Preguntas sobre ".concat(getProductTypeLabel(productType, 'shortPlural', 'lowercase')),
    align: "left"
  }), React.createElement(MainColumn, null, React.createElement(Three, {
    gap: "0px 12px"
  }, questions.map(function (question, i) {
    return React.createElement(Question, {
      key: i,
      variant: "small",
      question: question
    });
  })))));
};
export default withSubscriptions(DTopicSection, ['products']);